export const QUESTIONNAIRE_API = {
  getQuestionnaireQuestions: (name: string) => `/questionnaires/${name}`,
  submitQuestionnaireAnswers: (name: string) =>
    `/questionnaires/${name}/answers`,
};
